
// BotoesdeNavegacao.js

import React from 'react';
import Button from '@mui/material/Button';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import LastPageIcon from '@mui/icons-material/LastPage';

  const BotoesdeNavegacao = ({ fetchPrimeiro, fetchAnterior, fetchProximo, fetchUltimo }) => {
  
  const buttonStyles = {
    marginRight: '10px',
    minWidth: '60px',
    padding: '3px 6px',
    fontSize: '0.7rem',
  };


  return (
    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '0px', marginTop: '10px' }}>
      <Button
        variant="outlined"
        color="primary"
        style={buttonStyles}
        startIcon={<FirstPageIcon />}
        onClick={fetchPrimeiro}
      >
        Primeiro
      </Button>
      <Button
        variant="outlined"
        color="primary"
        style={buttonStyles}
        startIcon={<NavigateBeforeIcon />}
        onClick={fetchAnterior}
      >
        Anterior
      </Button>
      <Button
        variant="outlined"
        color="primary"
        style={buttonStyles}
        startIcon={<NavigateNextIcon />}
        onClick={fetchProximo}
      >
        Próximo
      </Button>
      <Button
        variant="outlined"
        color="primary"
        style={buttonStyles}
        startIcon={<LastPageIcon />}
        onClick={fetchUltimo}
      >
        Último
      </Button>
    </div>
  );
};

export default BotoesdeNavegacao;